module.exports = __webpack_public_path__ + "static/media/fitness.6d1d7a52.pdf";